import {useMemo} from 'react';
import type {ExpressionExportProps, ExpressionV4} from '../types';

export const useExpressionExports = (
  expression: Pick<ExpressionV4, 'expressionFormat'>,
): ExpressionExportProps => {
  return useMemo(
    () => ({
      expressionFormat: expression.expressionFormat,
    }),
    [expression.expressionFormat],
  );
};
